import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import "./App.css";
import Dashboard from "./webpages/dashboard";
import Attendance from "./webpages/attendance";
import Assignment from "./webpages/assignment";
import Tutors from "./webpages/tutors";
import Payments from "./webpages/payments";
import DealDetails from "./webpages/deal-details";
import axios from "./axios";
import MyProfile from "./webpages/myProfile/myProfile";
import PersonalInfo from "./webpages/myProfile/personalInfo";
import Settings from "./webpages/myProfile/settings";
import NewRequest from "./webpages/NewRequest/new-request";
import AcademyRequest from "./webpages/NewRequest/academy-request";
import LoginPage from "./webpages/login-page";
import NeedATutor from "./need-a-tutor";
import WaLogin from "./webpages/waLogin";
import Counselling from "./webpages/counselling";
import { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import NewAddress from "./webpages/myProfile/newAddress";
import Header from "./components/Header";
import Logout from "./webpages/Logout";
import DemoTutors from "./components/demo-tutors";
import Footer from "./components/Footer";
import MyRequests from "./webpages/myProfile/MyRequests";
import Subscription from "./webpages/myProfile/subscription";
import FAQ from "./webpages/myProfile/FAQ";
import NeedHelp from "./webpages/myProfile/NeedHelp";
import GiveFeedback from "./webpages/myProfile/giveFeedback";
import PaymentSuccess from "./webpages/payment-success";
import PaymentFailure from "./webpages/payment-failure";
import NotificationToast from "./components/NotificationToast";
import { setupForegroundMessageHandler, trackNotificationClick } from "./notification";
import OnlineTutor from "./online-tutor";
import FooterPage from "./components/footerpage";

function AppContent() {
  const [isMobile, setIsMobile] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [showMobileNavigation, setShowMobileNavigation] = useState(false);
  const [showNavBar, setshowNavBar] = useState(false);
  const [showLogin, setShowLogin] = useState(true);
  const [notification, setNotification] = useState(null);
  const navigate = useNavigate();

  ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID);

  // Request notification permission on app load
  useEffect(() => {
    if ("Notification" in window && Notification.permission === "default") {
      Notification.requestPermission();
    }
  }, []);

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: "Home Page",
    });
    if (JSON.parse(localStorage.getItem("homeshiksha-jwt"))) {
      getDashboardDetails();
      setshowNavBar(true);

      // Setup FCM foreground message handler
      const unsubscribe = setupForegroundMessageHandler(message => {
        console.log("📩 Notification received in foreground:", message);
        setNotification(message);
      });

      return () => {
        if (unsubscribe) unsubscribe();
      };
    } else {
      setshowNavBar(false);
      if (["/", "/wa-login"].includes(window.location.pathname)) {
        setShowLogin(true);
        setshowNavBar(false);
      } else setShowLogin(false);
    }

    setIsMobile(window.innerWidth <= 768);
  }, []);

  const getDashboardDetails = () => {
    axios
      .get(`v1/student/dashboard`)
      .then(data => {
        const response = data.data;
        setUserDetails({
          profilePic: response.profile_pic,
          Name: response.user_name,
          userId: response.id,
        });
      })
      .catch(err => {
        setUserDetails({ profilePic: null });
      });
  };

  const resetPopUp = () => {
    // navigate to dashboard
    navigate("/dashboard");
  };

  const handleNotificationClose = () => {
    setNotification(null);
  };

  const handleTrackClick = historyId => {
    if (historyId) {
      trackNotificationClick(historyId);
    }
  };

  return (
    <div className="App">
      <Header />

      {/* Notification Toast */}
      {notification && (
        <NotificationToast
          notification={notification}
          onClose={handleNotificationClose}
          onTrackClick={handleTrackClick}
        />
      )}

      <Routes>
        <Route exact path="/" element={<LoginPage />} />
        <Route path="/dashboard" element={<Dashboard setshowNavBar={setshowNavBar} />} />
        <Route path="/attendance" element={<Attendance />} />
        <Route path="/assignment" element={<Assignment />} />
        <Route path="/tutors" element={<Tutors />} />
        <Route path="/counselling" element={<Counselling />} />
        <Route path="/payments" element={<Payments />} />
        <Route path="/deal-details" element={<DealDetails />} />
        <Route path="/my-profile" element={<MyProfile />} />
        <Route path="/my-requests" element={<MyRequests />} />
        <Route path="/subscription" element={<Subscription />} />
        <Route path="/faq" element={<FAQ />} />
        {/* <Route path="/policy" element={<Policy />} /> */}
        <Route path="/need-help" element={<NeedHelp />} />
        <Route path="/personal-info" element={<PersonalInfo />} />
        <Route path="/address" element={<NewAddress />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/new-request" element={<NewRequest />} />
        <Route path="/new-academy-request" element={<AcademyRequest />} />
        <Route path="/need-a-tutor" element={<NeedATutor />} />
        <Route path="/need-a-tutor/shadow" element={<NeedATutor />} />
        <Route path="/wa-login/:randomString" element={<WaLogin />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/demo" element={<DemoTutors isDemoPage={true} />} />
        <Route path="/give-feedback" element={<GiveFeedback onClose={resetPopUp} />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-failure" element={<PaymentFailure />} />
        <Route path="/online-tutor" element={<OnlineTutor />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
